<ng-content></ng-content>

<div class="menu-container">
  <dx-tree-view
    [items]="items"
    keyExpr="path"
    selectionMode="single"
    expandEvent="click"
    (onItemClick)="onItemClick($event)"
    (onContentReady)="onContentReady($event)"
    width="100%"
  >
  </dx-tree-view>
</div>
